export interface PdfMergeInstruction {
  pdfs: {
    title: string;
    data: Uint8Array<ArrayBufferLike>;
    start_page: number;
    end_page: number;
  }[];
  title: string;
  author: string;
}

export async function mergePdfs(instruction: PdfMergeInstruction) {
  const worker = new Worker(new URL('./pdf-worker.ts', import.meta.url), {
    type: 'module'
  });
  await new Promise<MessageEvent>(resolve =>
    worker.addEventListener('message', resolve, { once: true })
  );
  worker.postMessage(instruction);
  const event = await new Promise<
    MessageEvent<{ type: 'pdf-error' } | { type: 'pdf-data'; data: Uint8Array }>
  >(resolve => worker.addEventListener('message', resolve, { once: true }));
  worker.terminate();
  if (event.data.type === 'pdf-error') {
    throw new Error('Error merging PDFs.');
  }
  return event.data.data;
}
